<template>
  <v-card>
    <v-card-title>ヘッダーの指定 IndexForm.vue</v-card-title>
    <v-card-text>
      <v-container>
        <v-form ref="form" v-model="valid">
          <v-row
            ><v-col cols="2">
              <v-text-field
                label="ソート対象のフォームID"
                v-model.number="sortkey"
                required
                :rules="[validation.numonly]"
                hint="formID 0だと作成順"
              ></v-text-field>
            </v-col>
            <v-col class="mt-0" cols="2">
              <v-radio-group label="" v-model="sort" row>
                <v-radio label="昇順" v-bind:value="'false'"></v-radio>
                <v-radio label="降順" v-bind:value="'true'"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col class="mt-0" cols="4">
              <v-checkbox
                v-model="rules8Flag"
                label="サブレポートを含む帳票を検索"
                value="true"
                @change="rules8Flag == 'true' ? (rule[8] = 'new') : ''"
              >
              </v-checkbox>
              <p>フォームIDに[サブフォームID.対象フォームID]で指定<br /></p>
            </v-col>
            <v-col class="mt-0" cols="3">
              <v-radio-group v-if="rules8Flag" label="" v-model="rule[8]" row>
                <v-radio label="最新" v-bind:value="'new'"></v-radio>
                <v-radio label="最古" v-bind:value="'old'"></v-radio>
                <v-radio
                  label="カンマ(,)区切りで表示"
                  v-bind:value="'join'"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row v-if="pageType == 8">
            <p>
              *デフォルトで[ユーザ名,メールアドレス,権限]がヘッダーに表示されます<br />
              *form_id [-1:ユーザ名, -2:メールアドレス -3:権限]で位置指定が可能
            </p>
            rules8Flag
          </v-row>
          <v-row>
            <div v-for="(head, i) in headers[0]" :key="i" class="mb-4">
              <v-col cols="12">
                <v-text-field
                  label="表示名"
                  v-model="head.text"
                  required
                ></v-text-field>
                <search-Page
                  label="フォームID*2"
                  v-model.number="head.value"
                  required
                  samePage
                  :initPageID="Number(pageID)"
                ></search-Page>
              </v-col>
            </div>
          </v-row>
          <v-row>
            <p>*アイコンの表記は左から順番に判断されます</p>
          </v-row>
          <v-row>
            <v-btn color="red white--text" @click="del" class="ma-2"
              >削除</v-btn
            >
            <v-btn color="success" @click="add" class="ma-2">追加</v-btn>
          </v-row>
          <v-row>
            <v-col cols="3">
              <v-checkbox v-model="rule[6]" label="別タブで開く" value="true">
              </v-checkbox>
            </v-col>
            <v-col cols="3">
              <v-checkbox
                v-model="rule[7]"
                label="戻るボタンを常時表示"
                value="true"
                hint="左上に常に表示"
              >
              </v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="5">
              <v-checkbox
                v-model="check[0]"
                label="ユーザ情報に紐づく特定条件のレポートのみ表示"
              >
              </v-checkbox>
            </v-col>
            <v-col cols="3" v-if="check[0]">
              <v-select
                :items="valueType"
                item-text="text"
                item-value="value"
                hint="制限対象のフォームが１つの時に適用されます"
                v-model="rule[5]"
                label="対象の値"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col v-if="check[0]" cols="6">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    label="制限対象のフォームID"
                    v-model="rule[0]"
                    :rules="[validation.numANDperiod]"
                    v-bind="attrs"
                    v-on="on"
                  >
                  </v-text-field>
                </template>
                <span
                  >ユーザ情報formなら1個,ユーザ情報設定ページに存在するフォームの場合(検索対象ID.ユーザ情報ページのfomrID)</span
                >
              </v-tooltip></v-col
            >
          </v-row>
          <v-row>
            <v-col cols="2"
              ><v-checkbox v-model="check[1]" label="表示変換"></v-checkbox
            ></v-col>
          </v-row>
          <div v-for="(c, i) in converts" :key="i" class="mb-4">
            <v-row v-if="check[1]">
              <v-col>
                <v-text-field label="フォームID*3" v-model="targets[i]">
                </v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-if="
                    converts[i] == 'target' ||
                      converts[i] == 'state' ||
                      converts[i] == 'newest'
                  "
                  :label="converts[i] == 'state' ? 'ラベル.X' : 'ラベル'"
                  v-model="targetLabels[i]"
                >
                </v-text-field>
              </v-col>
              <v-col>
                <v-select
                  v-if="
                    converts[i] == 'target' ||
                      converts[i] == 'state' ||
                      converts[i] == 'newest'
                  "
                  :items="$store.state.colors"
                  :background-color="targetColors[i]"
                  v-model="targetColors[i]"
                  label="カラー"
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-if="check[1]">
              <v-col>
                <v-radio-group
                  label="表示形式変換"
                  v-model="converts[i]"
                  required
                  row
                >
                  <v-radio label="日付のみ" value="dayOnly"></v-radio>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-radio
                        label="年月日時分"
                        value="dayTime"
                        v-bind="attrs"
                        v-on="on"
                      ></v-radio>
                    </template>
                    <span>
                      (日付+日時)→yyyy年mm月hh日hh時mm分
                    </span>
                  </v-tooltip>
                  <v-radio label="時分秒表示" value="convertDay"></v-radio>
                  <v-radio label="n個表示" value="count"></v-radio>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-radio
                        label="[作業中+中断中]アイコン*"
                        value="work"
                        v-bind="attrs"
                        v-on="on"
                      ></v-radio>
                    </template>
                    <span>
                      *1
                      [終了判定formID(.)中断判定formID],ヘッダー左端固定,かつIDは終了判定対象のID
                    </span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-radio
                        label="1つの値指定アイコン*"
                        value="target"
                        v-bind="attrs"
                        v-on="on"
                      >
                      </v-radio>
                    </template>
                    <span>
                      *現在仕様として追加された条件に合致するものが複数あればラベル、カラーは最後に合致したものに上書きされます。
                    </span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-radio
                        label="アイコン表示(ID1個)*"
                        value="state"
                        v-bind="attrs"
                        v-on="on"
                      >
                      </v-radio>
                    </template>
                    <span>
                      formIDがIf == X1の時,ラベルと色をつけてアイコン表示
                    </span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-radio
                        label="最新状態アイコン"
                        value="newest"
                        v-bind="attrs"
                        v-on="on"
                      >
                      </v-radio>
                    </template>
                    <span>
                      指定したformIDの値の時刻を見ているため、時刻が格納されている前提の動作
                    </span>
                  </v-tooltip>
                </v-radio-group>
              </v-col>
            </v-row>
          </div>

          <v-row v-if="check[1]">
            <v-btn color="primary" class="ma-2" @click="rule2del">削除</v-btn>
            <v-btn color="success" class="ma-2" @click="rule2add"
              >対象追加</v-btn
            >
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="success" @click="submit">OK</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import searchPage from "../ReportCreate/common/searchPage.vue";
export default {
  props: {
    headers: Array,
    rules: String,
    name: String,
    pageType: Number,
    pageID: String,
  },
  components: {
    searchPage,
  },
  data() {
    return {
      returnData: {
        headers: this.headers,
        rules: this.rule,
        name: "",
      },
      valueType: [
        { text: "名前", value: "name" },
        { text: "メールアドレス", value: "email" },
        { text: "uuID", value: "sub" },
      ],
      check: [false, false],
      //
      //0:ユーザ名のみ一覧表示するか(検索範囲の限定)
      //1:ヘッダーの特定項目を「年月日のみ」「時分秒」表記に変更
      rule: [""],
      targets: [""],
      targetLabels: [""],
      targetColors: [""],
      converts: [""],
      //
      sortkey: 0,
      sort: "false",
      //サブレポートを表示するか
      rules8Flag: false,
      //バリデーション
      valid: true,
      validation: {
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
        numOrTarget: (value) => {
          return (
            /^[-0-9]*$/.test(value) ||
            /^target$/.test(value) ||
            "数値 or targetのみ"
          );
        },
        numANDperiod: (value) => {
          return /^[0-9.]*$/.test(value) || "数値ピリオドのみ";
        },
        formID: (value) => {
          return (
            /^[0-9]*$/.test(value) ||
            /^workcheck$/.test(value) ||
            "数値 or workcheckのみ"
          );
        },
      },
    };
  },
  mounted() {
    try {
      if (typeof this.rules != "undefined") {
        //-----nameをパラメータに使ってしまっている-----
        let tmp = this.name.split(",");
        this.sortkey = Number(tmp[0]);
        this.sort = String(tmp[1]);
        //--------------------------------------------
        this.rule = this.rules.split(",");
        if (this.rule[0] != "") {
          this.$set(this.check, 0, true);
        }
        if (this.rule[8] != "") {
          this.rules8Flag = "true";
        }
        if (this.nullCheck(this.rule[1])) {
          this.check[1] = true;
          this.targets = this.rule[1].split(":");
          this.converts = this.rule[2].split(":");
          this.targetLabels = this.rule[3].split(":");
          this.targetColors = this.rule[4].split(":");
        }
        if (this.rule[5] == "undefined") {
          this.rule[5] = "name";
        }
      }
    } catch (e) {
      console.log("error:", e);
    }
  },
  methods: {
    submit() {
      //バリデーション
      if (this.$refs.form.validate()) {
        if (this.check[0] != true) {
          this.rule[0] = null;
          this.rule[5] = null;
        }
        if (this.check[1] != true) {
          this.rule[1] = null;
          this.rule[2] = null;
          this.rule[3] = null;
          this.rule[4] = null;
        } else {
          this.rule[1] = this.targets.join(":");
          this.rule[2] = this.converts.join(":");
          this.rule[3] = this.targetLabels.join(":");
          this.rule[4] = this.targetColors.join(":");
        }
        if (this.rules8Flag != "true") {
          this.rule[8] = "";
        }
        this.returnData.name = this.sortkey + "," + String(this.sort);
        this.returnData.rules = this.rule.join(",");
        this.$emit("clickSubmit", this.returnData);
      }
    },
    add() {
      this.headers[0].push({
        text: "",
        value: 0,
      });
    },
    del() {
      if (this.pageType == 8) {
        this.headers[0].splice(-1, 1);
      } else if (this.headers[0].length > 1) {
        this.headers[0].splice(-1, 1);
      }
    },
    rule2add() {
      this.converts.push("");
      this.targets.push("");
      this.targetLabels.push("");
      this.targetColors.push("");
    },
    rule2del() {
      this.converts.splice(-1, 1);
      this.targets.splice(-1, 1);
      this.targetLabels.splice(-1, 1);
      this.targetColors.splice(-1, 1);
    },
    toBoolean(data) {
      return data.toLowerCase() === "true";
    },
    /* 正常な値が入っていればtrue */
    nullCheck(value) {
      let checkFlag = true;
      switch (value) {
        case "":
        case "undefined":
        case null:
        case undefined:
        case false:
          checkFlag = false;
      }

      return checkFlag;
    },
  },
};
</script>
